import { ConflictType } from '@editor2/types/conflict';
import { ElementDeletedModifiedConflictResolver } from './deletedModifiedResolver';
import { ElementItemMoveConflictResolver } from './itemMoveResolver';
import { ElementModifiedDeletedConflictResolver } from './modifiedDeletedResolver';
import { ElementPropertyConflictResolver } from './propertyResolver';

export class ElementResolver {
	getTypeResolver = (key: ConflictType) => {
		switch (key) {
			case ConflictType.Property: {
				const resolver = new ElementPropertyConflictResolver();
				return resolver;
			}

			case ConflictType.DeletedModified: {
				const resolver = new ElementDeletedModifiedConflictResolver();
				return resolver;
			}

			case ConflictType.ModifiedDeleted: {
				const resolver = new ElementModifiedDeletedConflictResolver();
				return resolver;
			}

			case ConflictType.ItemMove: {
				const resolver = new ElementItemMoveConflictResolver();
				return resolver;
			}

			default:
				break;
		}
	};
}
